<div class="password-feedback" [attr.data-level]="isPristine ? 'neutro' : level">
  <div class="password-feedback__segments" aria-hidden="true">
    @for (segment of segments; track segment) {
      <span class="password-feedback__segment" [class.is-on]="segment <= filledCount"></span>
    }
  </div>
  @if (!isPristine) {
    <p class="password-feedback__label">{{ label }}</p>
  }

  <ul class="password-feedback__rules">
    <li [class.is-valid]="hasMinLength" [class.is-neutral]="isPristine">
      @if (isPristine) {
        <span class="password-feedback__dot" aria-hidden="true"></span>
      } @else {
        <l-icon>{{ hasMinLength ? 'check' : 'close' }}</l-icon>
      }
      <span>Mínimo de 6 caracteres</span>
    </li>
    <li [class.is-valid]="passwordsMatch" [class.is-neutral]="isPristine">
      @if (isPristine) {
        <span class="password-feedback__dot" aria-hidden="true"></span>
      } @else {
        <l-icon>{{ passwordsMatch ? 'check' : 'close' }}</l-icon>
      }
      <span>As senhas devem ser iguais</span>
    </li>
  </ul>
</div>
